import {
  Consumer,
  Person
} from '../index';

declare var Object: any;
export interface ConsumerEmPersonInterface {
  "relation"?: string;
  "dtime"?: Date;
  "id"?: number;
  "consumerId"?: number;
  "personId"?: number;
  consumer?: Consumer;
  person?: Person;
}

export class ConsumerEmPerson implements ConsumerEmPersonInterface {
  "relation": string;
  "dtime": Date;
  "id": number;
  "consumerId": number;
  "personId": number;
  consumer: Consumer;
  person: Person;
  constructor(data?: ConsumerEmPersonInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `ConsumerEmPerson`.
   */
  public static getModelName() {
    return "ConsumerEmPerson";
  }

  /**
  * This method creates an instance of ConsumerEmPerson for dynamic purposes.
  **/
  public static factory(data: ConsumerEmPersonInterface): ConsumerEmPerson{
    return new ConsumerEmPerson(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ConsumerEmPerson',
      plural: 'ConsumerEmPeople',
      path: 'ConsumerEmPeople',
      idName: 'id',
      properties: {
        "relation": {
          name: 'relation',
          type: 'string'
        },
        "dtime": {
          name: 'dtime',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "consumerId": {
          name: 'consumerId',
          type: 'number'
        },
        "personId": {
          name: 'personId',
          type: 'number'
        },
      },
      relations: {
        consumer: {
          name: 'consumer',
          type: 'Consumer',
          model: 'Consumer',
          relationType: 'belongsTo',
                  keyFrom: 'consumerId',
          keyTo: 'id'
        },
        person: {
          name: 'person',
          type: 'Person',
          model: 'Person',
          relationType: 'belongsTo',
                  keyFrom: 'personId',
          keyTo: 'id'
        },
      }
    }
  }
}
